import BackgroundVideo from '../../../resources/scripts/helpers/background-video';

class BrixSpacer {
  static init(...parameters) {
    return new BrixSpacer(...parameters);
  }

  constructor(block) {
    if (block) {
      const backgroundVideoWrapper = document.querySelector(`#${block.id} > .background > .video`);

      if (backgroundVideoWrapper) {
        BackgroundVideo.init(block);
      }
    }
  }
}

// Register class
if (window.brix && window.brix.registerBlock) {
  window.brix.registerBlock('brix-spacer', BrixSpacer.init);
}
